const csrfAccessDeniedErrorTemplate = `
<div class="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2">
	<header class="contained-form-header margin-top-default">
    <h1>
      {{ "error.csrfheadingTitle" | translate }}
    </h1>
  </header>
  <div class="inner-container with-padding with-shadow">  	
  	<p> {{'error.csrf1' | translate}} <a ng-click='loginLinkClick()'> login.</a> {{'error.csrf2' | translate}}</p>
  	</div>
</div>
`;
export default csrfAccessDeniedErrorTemplate;